import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from '~/base/BaseServices.module.scss';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

// const DigitalTransformation = ({ t }) => {
const DigitalTransformation = () => {
    const { t } = useTranslation();
    let { pathname } = useLocation();

    const data = {
        title: t('Digital Transformation Services that Help Businesses Champion Change'),
        indexClass: 1,
        titleTech: t('We believe every business'),
        video: 'https://video.wixstatic.com/video/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4/720p/mp4/file.mp4',
        titleContent: t('Digital transformation'),
        poster: 'https://static.wixstatic.com/media/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4f000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4f000.jpg',
        content: t('Our digital business transformation services'),
    };
    const detailServices = [
        {
            label: t('Cloud Computing & Migration'),
            description: t('Adoption of cloud platforms (AWS, Azure, Google Cloud)'),
            image: require('../../assets/images/services/digital-transformation/cloud-computing-migration.png'),
        },
        {
            label: t('AI & Automation'),
            description: t('Leverage artificial intelligence solutions'),
            image: require('../../assets/images/services/digital-transformation/ai-automation.png'),
        },
        {
            label: t('Data Analytics & Business Intelligence'),
            description: t('Transform data into actionable insights'),
            image: require('../../assets/images/services/digital-transformation/data-analytics-business-intelligence.png'),
        },
        {
            label: t('IoT (Internet of Things) Solutions'),
            description: t('Integrate IoT devices and sensors'),
            image: require('../../assets/images/services/digital-transformation/iot.png'),
        },
        {
            label: t('Cybersecurity & Compliance'),
            description: t('Protect your digital assets'),
            image: require('../../assets/images/services/digital-transformation/cybersecurity-compliance.png'),
        },
        {
            label: t('Customer Experience Transformation'),
            description: t('Enhance customer journey and satisfaction'),
            image: require('../../assets/images/services/digital-transformation/customer-experience-transformation.png'),
        },
        {
            label: t('Blockchain Solutions'),
            description: t('Implement secure blockchain technology'),
            image: require('../../assets/images/services/digital-transformation/blockchain-solutions.png'),
        },
        {
            label: t('Enterprise Software & ERP Solutions'),
            description: t('Streamline business processes'),
            image: require('../../assets/images/services/digital-transformation/erp.png'),
        },
    ]
    const ctaData = {
        title: t('Let’s navigate your digital transformation, together'),
        description: t('We can help you take your next step, whether you\'re just starting out or well on your way already'),
    }

    return (
        <div className={cx('solution')}>
            <div className={cx('solution__intro')}>
                <div
                    className={cx('solution__intro-wraper')}
                    style={{
                        position: 'absolute',
                        maxWidth: '900px',
                        left: '110px',
                        top: '26px',
                    }}
                >
                    <div className={cx('solution__intro__title')}>{data.title}</div>
                    <div className={cx('solution__intro__description')}>{data.titleTech}</div>
                </div>
            </div>

            <div className={cx('solution__new', 'solution__new-service-' + data.indexClass)}>
                <div className={cx('solution__new__top')}>
                    <div className={cx('solution__new__top__content')}>{data.titleContent}</div>
                    <div className={cx('solution__new__top__content-two')}>
                        <p>{data.content}</p>
                    </div>
                </div>
                <div>
                    {window.innerWidth > 768 ? (
                        <video
                            crossOrigin="anonymous"
                            playSinline="true"
                            preload="auto"
                            loop
                            tabIndex="-1"
                            autoPlay
                            muted
                            src={data.video}
                            className="desktop-video"
                            style={{ width: '800px', maxWidth: '100%' }}
                        ></video>
                    ) : (
                        <img style={{ width: '100%' }} src={data.poster} alt="Mobile Image" />
                    )}
                </div>
            </div>
            {/* Services Grid Section */}
            <div className={cx("solution__services", "solution__services__" + pathname.split('/')[1])}>
                <div className={cx("solution__services__title")}>
                    {t("Enabling tomorrow today with our digital transformation service")}
                </div>

                <div className={cx("solution__services__description")}>
                    {t("Our digital transformation services will boosts operational effectiveness and productivity of your company.")}
                </div>

                <div className={cx("solution__services__grid")}>
                    {detailServices.map((service, index) => (
                        <div className={cx("solution__services__item")}>
                            <div className={cx("solution__services__item__image")}>
                                <img src={service.image} alt={service.label} />
                            </div>
                            <div className={cx("solution__services__item__content")}>
                                <div className={cx("solution__services__item__content__text")}>
                                    <h3>{service.label}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <div className={cx("solution__services__item__content__arrow")}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Call to Action Section */}
            <div className={cx("solution__cta")}>
                <div className={cx("solution__cta__content", "solution__cta__content__" + pathname.split('/')[1])}>
                    <div className={cx("solution__cta__text")}>
                        <h2>{ctaData.title}</h2>
                        <p>{ctaData.description}</p>
                        <Link to="/contact" className={cx("solution__cta__button")}>
                            {t("CONTACT US >")}
                        </Link>
                    </div>
                    {/* <div className={cx("solution__cta__image")}></div> */}
                </div>
            </div>
        </div>
    )
}

export default DigitalTransformation
